<div class="main-section relative font-nunito text-sm font-normal antialiased min-h-screen bg-white dark:bg-[#04040f]"
  [ngClass]="[store.sidebar ? 'toggle-sidebar' : '', store.menu, store.layout, store.rtlClass]">
  <!-- BEGIN MAIN CONTAINER -->
  <div class="relative">
    <!-- sidebar menu overlay -->
    <div class="fixed inset-0 z-50 bg-[black]/60 lg:hidden" [ngClass]="{ hidden: !store.sidebar }"
    (click)="storeData.dispatch({ type: 'toggleSidebar' })"></div>


    <!-- screen loader -->
    @if (store.isShowMainLoader) {
      <div
        class="screen_loader fixed inset-0 bg-[#fafafa] dark:bg-[#060818] z-[60] grid place-content-center animate__animated">
        <svg width="64" height="64" viewBox="0 0 135 135" xmlns="http://www.w3.org/2000/svg" fill="#4361ee">
          <path
            d="M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z">
            <animateTransform attributeName="transform" type="rotate" from="0 67 67" to="-360 67 67" dur="2.5s"
            repeatCount="indefinite"></animateTransform>
          </path>
          <path
            d="M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z">
            <animateTransform attributeName="transform" type="rotate" from="0 67 67" to="360 67 67" dur="8s"
            repeatCount="indefinite"></animateTransform>
          </path>
        </svg>
      </div>
    }


    @if(showTopButton){
      <div class="fixed bottom-14 z-50 ltr:right-2 rtl:left-6">
        <button type="button"
          class="animate-pulse rounded-full bg-[#fafafa] p-2 dark:bg-[#060818] dark:hover:bg-primary border border-[#E1E4EA] dark:border-[#1b2e4b]"
          (click)="goToTop()">
          <svg width="24" height="24" class="h-4 w-4" viewBox="0 0 24 24" fill="none" class="text-secondary"
            xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd"
              d="M12 20.75C12.4142 20.75 12.75 20.4142 12.75 20L12.75 10.75L11.25 10.75L11.25 20C11.25 20.4142 11.5858 20.75 12 20.75Z"
              fill="currentColor" />
              <path
                d="M6.00002 10.75C5.69667 10.75 5.4232 10.5673 5.30711 10.287C5.19103 10.0068 5.25519 9.68417 5.46969 9.46967L11.4697 3.46967C11.6103 3.32902 11.8011 3.25 12 3.25C12.1989 3.25 12.3897 3.32902 12.5304 3.46967L18.5304 9.46967C18.7449 9.68417 18.809 10.0068 18.6929 10.287C18.5768 10.5673 18.3034 10.75 18 10.75L6.00002 10.75Z"
                fill="currentColor" />
              </svg>
            </button>
          </div>
        }


        <!-- BEGIN APP SETTING LAUNCHER -->
        <setting></setting>
        <!-- END APP SETTING LAUNCHER -->


        <div class="main-container min-h-screen text-black dark:text-white-dark" [ngClass]="[store.navbar]">
          <!-- BEGIN SIDEBAR -->


          <sidebar></sidebar>


          <!-- END SIDEBAR -->
          <div class="main-content flex flex-col min-h-screen relative">
            <!-- BEGIN TOP NAVBAR -->


            <header></header>

            
            <!-- END TOP NAVBAR -->
            
            
            <!-- BEGIN CONTENT AREA -->
            <div class="w-full max-w-[1400px] mx-auto animation !pb-0 mb-10"
              [ngClass]="contentPaddingClass">
              <router-outlet></router-outlet>
            </div>
            <!-- END CONTENT AREA -->


            <!-- BEGIN FOOTER -->
            <footer class="fixed bottom-0 left-0 right-0 !w-full z-20"></footer>
            <!-- END FOOTER -->
          </div>
        </div>


        <app-timezone-completion-alert-popup></app-timezone-completion-alert-popup>
        <app-profile-completion-alert-popup></app-profile-completion-alert-popup>

        <!-- Session Warning Dialog -->
        <app-session-warning-dialog [show]="showWarning" (continueSession)="continueSession()" (logout)="logout()">
        </app-session-warning-dialog>
      </div>
    </div>